import React, { useEffect, useState } from "react";
import { bool, func, number, object as obj, string } from "prop-types";

import OnboardingFormStandard from "components/onboarding/OnboardingFormStandard";
import OnboardingFormPaginated from "components/onboarding/OnboardingFormPaginated";
import {
  failedLeadFormSubmission,
  successfulLeadSubmission
} from "data/segmentCustomEvents";
import LightBox from "components/shared/LightBox";
import SignupFailureModal from "components/signup/SignupFailureModal";
import SuperCarersOperations from "logic/SuperCarersOperations";

const OnboardingFormContainer = ({
  isMobile,
  isFormOpen,
  postcode,
  toggleFormOpenState,
  taxonomies,
  useVariant
}) => {
  const [formData, setFormData] = useState({
    confirmed_tos: false,
    firstname: "",
    lastname: "",
    name: "",
    email: "",
    newsLetterSignup: false,
    phone_number: "",
    requested_care_type: "",
    relationship: ""
  });
  const [serverError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [existingUser, setExistingUser] = useState(false);
  const [magicToken, setMagicToken] = useState(null);

  useEffect(() => {
    if (magicToken) {
      setTimeout(() => {
        window.open(
          `${window.SUPERCARERS_APP_URL}/magic_token/${magicToken}`,
          "_self"
        );
      }, 2000);
    }
  }, [magicToken]);

  const submit = async () => {
    setLoading(true);
    try {
      const customer = await SuperCarersOperations.createCustomer({
        confirmed_tos: formData.confirmed_tos,
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: formData.email,
        phone_number: formData.phone_number,
        newsLetterSignup: formData.newsLetterSignup
      });
      await SuperCarersOperations.createNeed({
        user_id: customer.id,
        lead_source: "onboarding",
        postcode,
        relationship: formData.relationship,
        requested_care_types: [formData.requested_care_type]
      });
      successfulLeadSubmission();
      setMagicToken(customer.magic_token);
      return true;
    } catch (e) {
      failedLeadFormSubmission();
      setError(true);
      setExistingUser(e.response && e.response.status === 409);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const dismissFailureModal = () => {
    setExistingUser(false);
    setError(false);
  };

  if (!taxonomies || !isFormOpen) {
    return null;
  }

  if (serverError) {
    return (
      <SignupFailureModal
        backgroundIds={["postcode-search", "map-header", "logo"]}
        existingUser={existingUser}
        onDismiss={dismissFailureModal}
        email={formData && formData.email}
      />
    );
  }

  const FormVariant = useVariant
    ? OnboardingFormPaginated
    : OnboardingFormStandard;

  if (isMobile) {
    return (
      <FormVariant
        formData={formData}
        isMobile
        loading={loading}
        magicToken={magicToken}
        setFormData={setFormData}
        submit={submit}
        taxonomies={taxonomies}
        toggleFormOpenState={toggleFormOpenState}
      />
    );
  }

  return (
    <LightBox>
      <FormVariant
        formData={formData}
        loading={loading}
        magicToken={magicToken}
        setFormData={setFormData}
        submit={submit}
        taxonomies={taxonomies}
        toggleFormOpenState={toggleFormOpenState}
      />
    </LightBox>
  );
};

OnboardingFormContainer.propTypes = {
  isFormOpen: bool,
  isMobile: bool,
  postcode: string.isRequired,
  toggleFormOpenState: func.isRequired,
  taxonomies: obj.isRequired,
  useVariant: number
};

export default OnboardingFormContainer;
